import { jsx as a } from "react/jsx-runtime";
import { I as d } from "../../../vendor-EQDp64ng.js";
import { createContext as m, useContext as l, useMemo as x, useRef as p } from "react";
const f = m(null);
function y() {
  const n = l(f);
  if (!n)
    throw new Error("useSelectFieldValueContext must be used within a SelectField");
  return n;
}
function M(n, r, t) {
  const e = /* @__PURE__ */ new Map();
  for (const s of r)
    e.set(s.id, s);
  const o = /* @__PURE__ */ new Map();
  let c = !1;
  for (const s of n) {
    const u = e.get(s), i = t.get(s);
    u ? (o.set(s, u), i !== u && (c = !0)) : i ? o.set(s, i) : c = !0;
  }
  return o.size !== t.size && (c = !0), c ? o : t;
}
function b(n) {
  const t = l(d)?.selectionManager.selectedKeys, e = p(/* @__PURE__ */ new Map());
  return t ? e.current = M(t, n, e.current) : e.current.size === 0 ? e.current : e.current = /* @__PURE__ */ new Map();
}
function C({
  items: n,
  children: r
}) {
  const t = b(n), e = x(
    () => ({ selectedItems: t }),
    [t]
  );
  return /* @__PURE__ */ a(f.Provider, { value: e, children: r });
}
export {
  C as SelectFieldValueProvider,
  y as useSelectFieldValueContext
};
